<template>
  <v-app id="inspire" :style="cssProps">
    <AppBar :drawer="drawer"></AppBar>
    <v-main class="grey lighten-3">
      <router-view></router-view>
    </v-main>
    <!-- <v-footer v-if="user" padless app>
      <v-col class="text-center" cols="12">
        <small>Copyright {{ new Date().getFullYear() }}  - MANUSHARE</small>
        <small class="float-right">v{{appVersion}}</small>
      </v-col>
    </v-footer> -->
  </v-app>
</template>

<script>
import { version } from '../package'
import logo from './assets/manushare.png'
import AppBar from './views/components/AppBar'
import { mapState } from 'vuex'

export default {
	name: 'App',
	components: { AppBar },
	data: () => ({
		logo,
		drawer: true,
		appVersion: version
	}),

	mounted () {
		this.$nextTick(() => {
			window.addEventListener('resize', this.onResize)
		})
		console.log('Manushare frontend version: ' + version)
	},

	computed: {
		cssProps () {
			const themeColors = {}
			Object.keys(this.$vuetify.theme.themes.light).forEach((color) => {
				themeColors[`--v-${color}`] = this.$vuetify.theme.themes.light[color]
			})
			return themeColors
		},
		...mapState('auth', ['user'])
	}
}
</script>

<style scoped>
.tab-logo {
  margin-right: 5px;
}
.v-avatar{
  margin: auto;
}
</style>

<style>
	.v-btn{
		text-transform: none;
	}
</style>
